import { useCallback, useEffect } from 'react';
import { useCookies } from 'react-cookie';
import { useDispatch } from 'react-redux';
import { useSelector } from 'src/client/redux/modules/helpers/useSelector';
import { loadUpgradableSites } from 'src/client/redux/modules/marketing';
import { HIDE_FREE_ACCESS_GATEWAY_COOKIE, HIDE_UPGRADE_STRIP_COOKIE } from 'src/shared/constants/cookies';
import { ONE_DAY } from 'src/shared/constants/times';

export const useUpgradeStrip = () => {
  const [cookies, setCookie] = useCookies([HIDE_FREE_ACCESS_GATEWAY_COOKIE, HIDE_UPGRADE_STRIP_COOKIE]);
  const upgradableSites = useSelector((state) => state.marketing.upgradableSites);
  const user = useSelector((state) => state.auth.user);
  const dispatch = useDispatch();

  // cookies as a whole changes when all the cookies change, so we save this
  // to a variable to prevent unnecessary dispatches.
  const hideUpgradeStripCookie = cookies[HIDE_UPGRADE_STRIP_COOKIE];

  const upgradeStripOpen = Boolean(upgradableSites.length && user?.validSubscription && !hideUpgradeStripCookie);

  useEffect(() => {
    if (user && !hideUpgradeStripCookie) {
      dispatch(loadUpgradableSites());
    }
  }, [user, hideUpgradeStripCookie, dispatch]);

  const closeUpgradeStrip = useCallback(() => {
    setCookie(HIDE_UPGRADE_STRIP_COOKIE, true, { path: '/', maxAge: ONE_DAY });
  }, [setCookie]);

  return [upgradeStripOpen, closeUpgradeStrip] as const;
};
